/*
Include this mixin to allow returning user pay by using existing card
*/
define('shared/initializer/form/adapters/mixins/Returnable',[
    '$',
    'shared/page/wcmmode',
    'shared/remote/member/get',
    'shared/remote/member/creditCard/get',
    'shared/remote/member/directDebit/get',
    'shared/remote/member/subscription',
    'shared/remote/payment/previous',
    'shared/page/apiVersion',
    'shared/lib/RSVP',
    'shared/initializer/form/constants',
    'shared/util/checkout/checkout',
    'shared/util/state',
    'shared/util/hub',
    'shared/util/state/adapters/persistent',
    'shared/util/checkout/PaymentMethodManager'
],
function(
    $, 
    getWCMMode, 
    getMember, 
    getMemberCreditCard, 
    getMemberDirectDebit, 
    getSubscription,
    getPrevious,
    getAPIVersion,
    RSVP, 
    constants,
    checkoutUtil,
    state,
    hub,
    persistentAdapter,
    PaymentMethodManager
){

    var DEBUG_KEY = 'persistent.debug_enable_returnable_mixin';
    var DISABLED = 'disabled';

    function createError(type, message){
        var err = new Error(message);
        err.type = type;
        return err;
    }

    function hideAllFields(){
        var me = this;
        for(var key in me.items){
            if ( !me.items.hasOwnProperty(key) ) {
                continue;
            }
        }
    }

    function hookFormEvents() {
        var me = this;
        me.$form.find('.form-group-existing-PayUsingNewCardLink .functional').on('click', function () {
            if ($(this).attr('disabled') != null) {
                return;
            }

            toggleInterface.call(me);
        });
    }

    function toggleInterface(previousPaymentInfo){
        var me = this;
        var existingCardNumber = previousPaymentInfo && previousPaymentInfo.number;
        var existingAccountName = previousPaymentInfo && previousPaymentInfo.name;
        var useExistingCard = existingCardNumber || existingAccountName;

        return getAPIVersion()
            .then(function(apiVersion){
                if (apiVersion !== 'new-house') {
                    if(useExistingCard){
                        me.$form.attr('action', me.$form.attr(Ctor.URL_CARD_EXISTING));
                    }
                    else{
                        me.$form.attr('action', me.$form.attr(Ctor.URL_CARD_NEW));
                    }
                }
            })
            .then(function(){
                for(var key in me.items){
                    if ( !me.items.hasOwnProperty(key) ) {
                        continue;
                    }

                    var lowerCaseKey = key.toLowerCase();
                    if (lowerCaseKey == constants.FIELD.PHONE_TYPE){
                        continue;
                    }

                    if (useExistingCard){
                        PaymentMethodManager.instance.useExisting = true;
                        if (
                            key == 'existing-tc' || 
                            key == 'existing-payusingnewcardlink' || 
                            key == 'existing-creditcardnumber' || 
                            key == 'existing-debitcardaccountname' || 
                            key == 'existing-debitcardnumber'
                        ){
                            me.items[key].$wrap.slideDown().closest('.row').slideDown();
                            if(key == 'existing-creditcardnumber' || key == 'existing-debitcardnumber'){
                                me.items[key].$el.val(existingCardNumber);
                                me.items[key].$el.attr('disabled', 'disabled');
                            }
                            else if(key == 'existing-debitcardaccountname'){
                                me.items[key].$el.val(existingAccountName);
                                me.items[key].$el.attr('disabled', 'disabled');
                            }
                            else{
                                me.items[key].$el.removeAttr('disabled');
                            }
                        }
                        else{
                            me.items[key].$wrap.slideUp().closest('.row').slideUp();
                            me.items[key].$el.attr('disabled', 'disabled');
                        }
                    }
                    else {
                        PaymentMethodManager.instance.useExisting = false;
                        if(key == 'existing-creditcardnumber'
                            || key == 'existing-tc'
                            || key == 'existing-payusingnewcardlink'
                            || key == 'existing-debitcardaccountname'
                            || key == 'existing-debitcardnumber'
                        ){
                            me.items[key].$wrap.slideUp().closest('.row').slideUp();
                            me.items[key].$el.attr('disabled', 'disabled');
                        }
                        else{
                            me.items[key].$wrap.slideDown().closest('.row').slideDown();
                            me.items[key].$el.removeAttr('disabled');
                        }
                    }
                }
            });
    }

    function getNewHousePreviousPayment() {
        return RSVP.all([getSubscription(), checkoutUtil.getCurrentFlowType()])
            .then(function(values){
                var subscription = values[0];
                var flowType = values[1];

                if (!subscription) {
                    return RSVP.reject(createError('redirect', 'NeverStudent'));
                }

                switch (subscription.Status) {
                    case 'Suspended':
                        return RSVP.reject(createError('redirect', 'SuspendedStudent'));
                    case 'Active':
                        if (flowType !== constants.CheckoutFlowType.Upsell) {
                            return RSVP.reject(createError('currentStudent', 'CurrentStudent'));    
                        }
                        break;
                    case 'Inactive':
                        break;
                }

                return getPrevious()
                    .then(function(previousPaymentInfo){
                        return {
                            number: previousPaymentInfo && previousPaymentInfo.AccountId,
                            // TODO: is the property name AccountName or something else
                            name: previousPaymentInfo && previousPaymentInfo.AccountName
                        };
                    });
            });
    }

    function getOldHousePreviousPayment() {
        var me = this;
        return getMember()
            .then(function (member) {
                if (!member) {
                    return RSVP.reject(createError('redirect', 'NeverStudent'));
                }

                switch (member.StudentType) {
                    case constants.StudentType.NeverStudent:
                        return RSVP.reject(createError('redirect', 'NeverStudent'));
                    case constants.StudentType.CurrentStudent:
                    case constants.StudentType.LapsedStudent:
                        if (me.type == constants.FormType.DirectDebit){
                            return getMemberDirectDebit()
                                .then(function (directDebitInfo) {
                                    return {
                                        number: directDebitInfo && directDebitInfo.AccountNumber, 
                                        name: directDebitInfo && directDebitInfo.AccountName
                                    };
                                });
                        }
                        else if(me.type == constants.FormType.CreditCard){
                            return getMemberCreditCard()
                                .then(function (memberCreditCardInfo) {
                                    return {
                                        number: memberCreditCardInfo && memberCreditCardInfo.Number
                                    };
                                });
                        }
                }
            });
    }

    function Ctor(){

    }

    Ctor.URL_CARD_EXISTING = 'data-action-using-existing-card';
    Ctor.URL_CARD_NEW = 'data-action-using-new-card';

    var p = Ctor.prototype;
    p.doPageLoad = function() {
        var me = this;
        var wcmmode;
        var flowType;
        var enableForDebugging = false;

        var prm = RSVP.resolve()
        .then(function(){
            return state.adapters.add(persistentAdapter);
        })
        .then(function(){
            hookFormEvents.call(me);
            
            hub
                .get('/debuglet/settings')
                .then(function(settings){
                    settings['Return form'] = {
                        getValue: function() {
                            return new RSVP.Promise(function(resolve) {
                                state
                                    .get(DEBUG_KEY)
                                    .then(function(values){
                                        resolve(values[0] && values[0].value || false);
                                    });
                            });
                        },
                        setValue: function(value) {
                            return new RSVP.Promise(function(resolve) {
                                state
                                    .push(DEBUG_KEY, {value: value})
                                    .then(function(){
                                        resolve();
                                    });
                            });
                        }
                    };
                });
        })
        .then(function(){
            return state.get(DEBUG_KEY);
        })
        .then(function(values){
            enableForDebugging = values[0] && values[0].value;
        })
        .then(function(){
            return checkoutUtil.getCurrentFlowType();
        })
        .then(function(type){
            flowType = type;
        })
        .then(function(){
            return getWCMMode();
        })
        .then(function(value){
            wcmmode = value;
        })
        .then(function(){
            if(wcmmode !== DISABLED || me.type == constants.FormType.PayPal){
                return RSVP.resolve();
            }

            hideAllFields.call(me);

            if (enableForDebugging) {
                return toggleInterface.call(me, {
                    number: '1234567890',
                    name: 'for debug'
                });
            }
            else if(
                flowType != constants.CheckoutFlowType.Return && 
                flowType != constants.CheckoutFlowType.Upsell
            ){
                return toggleInterface.call(me);
            }
            else {
                return getAPIVersion()
                    .then(function(apiVersion){
                        if (apiVersion === 'new-house') {
                            return getNewHousePreviousPayment.call(me);
                        }
                        else {
                            return getOldHousePreviousPayment.call(me);
                        }
                    })
                    .then(null, function () {
                        return null;
                    })
                    .then(function(previousPaymentInfo){
                        return toggleInterface.call(
                            me,
                            previousPaymentInfo
                        );
                    });
            }
        });

        return prm;
    };

    return Ctor;
});
